import React from "react";
import { useParams } from "react-router";
import { gql, useMutation, useQuery } from "@apollo/client";
import { Form } from "react-final-form";

import { Stack, Container } from "@mui/material";

import Layout from "components/common/Layout";
import SaveFab from "components/common/SaveFab";
import LegacyMouthpieceField from "components/mouthpiece/LegacyMouthpieceField";

const fragments = {
  legacyMouthpiece: gql`
    fragment Mouthpieces_LegacyMouthpiecePage_LegacyMouthpiece on LegacyMouthpiece {
      id
      instrument
      saxophoneType
      clarinetType
      name

      params {
        baffle
        chamber
        striations
        tipOpening
        tableFacing
        tableWidth
        design
        shank
        volume
      }

      stlFile {
        id
        url
        name
        path
        isPublic
      }
    }
  `,
};

const QUERY = gql`
  query ($legacyMouthpieceId: ID!) {
    legacyMouthpiece(id: $legacyMouthpieceId) {
      id

      ...Mouthpieces_LegacyMouthpiecePage_LegacyMouthpiece
    }
  }
  ${fragments.legacyMouthpiece}
`;

const MUTATION = gql`
  mutation (
    $id: ID!
    $instrument: String!
    $saxophoneType: String
    $clarinetType: String
    $name: String!
    $params: LegacyMouthpieceParamsInput!
    $stlFile: FileInput
  ) {
    UpdateLegacyMouthpiece(
      id: $id
      instrument: $instrument
      saxophoneType: $saxophoneType
      clarinetType: $clarinetType
      name: $name
      params: $params
      stlFile: $stlFile
    ) {
      legacyMouthpiece {
        id

        ...Mouthpieces_LegacyMouthpiecePage_LegacyMouthpiece
      }
    }
  }
  ${fragments.legacyMouthpiece}
`;

export default function LegacyMouthpiecePage() {
  const { legacyMouthpieceId } = useParams();

  const [updateLegacyMouthpiece] = useMutation(MUTATION);

  const { data, loading } = useQuery(QUERY, {
    variables: { legacyMouthpieceId },
  });

  if (loading) return <Layout.Loading />;
  if (!data?.legacyMouthpiece) return <Layout.NotFound />;

  return (
    <Container fixed sx={{ p: 2 }}>
      <Form
        onSubmit={({ legacyMouthpiece }) =>
          updateLegacyMouthpiece({
            variables: legacyMouthpiece,
          })
            .then(() => {})
            .catch(() => true)
        }
        initialValues={{ legacyMouthpiece: data.legacyMouthpiece }}
        keepDirtyOnReinitialize
      >
        {({ handleSubmit, form, pristine, submitting }) => (
          <form onSubmit={handleSubmit}>
            <Layout.Toolbar fixed>
              <Stack
                spacing={2}
                direction="row"
                alignItems="center"
                justifyContent="flex-end"
              >
                <SaveFab
                  onSave={handleSubmit}
                  disabled={pristine}
                  loading={submitting}
                />
              </Stack>
            </Layout.Toolbar>

            <LegacyMouthpieceField
              name="legacyMouthpiece"
              uploadBasePath={`mouthpieces/${data.legacyMouthpiece.id}`}
            />
          </form>
        )}
      </Form>
    </Container>
  );
}
